import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';

@Component({
    selector: 'app-meli-attributes',
    templateUrl: './meli-attributes.component.html',
    styleUrls: ['./meli-attributes.component.scss'],
    standalone: false
})
export class MeliAttributesComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData, private http:HTTPService,private uid:UserAuthenticationServices, private spinner:NgxSpinnerService,
  private cd:ChangeDetectorRef,public ThemeService:ThemeService) { }

  result = [];
  resultOb = new BehaviorSubject<Object>(null);
  ngOnInit(): void {
      
      let ob = {
        codeCompany : this.dialogData['CODECOMPANY']!=null? this.dialogData['CODECOMPANY']:this.uid.user.codecompany,
        method: 'GET',
        serviceName: 'GetItem',
      }

    
      ob['params'] = [{key:'@MLB', value: this.dialogData['id']}];

      this.spinner.show('attribspinner');
      this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(result=>{
          this.result = result['resultado'];
          this.resultOb.next(this.result);
          this.cd.markForCheck();
          this.spinner.hide('attribspinner');
      },error=>{
         this.spinner.hide('attribspinner');
      });


  }

}
